<template>
  <div> <!-- root element of the template -->
    <cm-attachments-devis-form v-if="devisForm" @close="devisForm = false" :devisFormData="devisFormData"></cm-attachments-devis-form>
    <cm-change-password-popup v-if="changePasswordPopup" @close="changePasswordPopup = false" :data="changePasswordPopupData" class="z-10080"></cm-change-password-popup>
    <cm-payment-axepta v-if="paymentAxepta" @close="paymentAxepta = false" :paymentDetails="paymentDetails"></cm-payment-axepta>
    <bank-account-qr-code v-if="bankAccountQRCode" @close="bankAccountQRCode = false" :accountId="accountId"></bank-account-qr-code>
    <choice-bank-account v-if="choiceBankAccount" @close="choiceBankAccount = false" :data="choiceBankAccountData"></choice-bank-account>
    <choice-payment-cancel v-if="choicePaymentCancel" @close="choicePaymentCancel = false" :data="choicePaymentCancelData"></choice-payment-cancel>
    <choice-payment-instalment v-if="choicePaymentInstalment" @close="choicePaymentInstalment = false" :data="choicePaymentInstalmentData"></choice-payment-instalment>
    <choice-payment-refuse v-if="choicePaymentRefuse" @close="choicePaymentRefuse = false" :data="choicePaymentRefuseData"></choice-payment-refuse>
    <choice-reject-payment v-if="choiceRejectPayment" @close="choiceRejectPayment = false" :data="choiceRejectPaymentData"></choice-reject-payment>
    <scanner-qr-code v-if="scannerQRCode" @close="scannerQRCode = false" :content="scannerQRCodeContent"></scanner-qr-code>
    <cm-service-popups></cm-service-popups>
    <cm-service-switcher-popup :closeButton="true"></cm-service-switcher-popup>
    <cm-switch-profile :closeButton="true"></cm-switch-profile>
    <cm-user-reset-password :closeButton="true"></cm-user-reset-password>
    <!-- <cm-switch-profile :closeButton="false"></cm-switch-profile> -->
    <document-viewer v-if="documentViewer" @close="documentViewer = false" :data="documentViewerData"></document-viewer>
    <import-file v-if="importFile" @close="importFile = false" :importFileData="importFileData"></import-file>
    <xml-details v-if="xmlDetails" @close="xmlDetails = false" :xmlDetailsData="xmlDetailsData" ></xml-details>
  </div>
</template>

<script>
// contacts
import CMAddContact from '@/popups/contacts/CMAddContact.vue'
import CMAddContactGroup from '@/popups/contacts/CMAddContactGroup.vue'
import CMEditContact from '@/popups/contacts/CMEditContact.vue'
// services
import CMServicePopups from '@/popups/services/Popups.vue'
// service switch
import ServicesSwitcherPopup from '@/popups/ServicesSwitcherPopup.vue'
import ProfileSwitcherPopup from '@/popups/switchProfile/switchProfile.vue'

import CMAttachmentsDevisForm from '@/popups/attachments/CMAttachmentsDevisForm.vue'
import CMPaymentAxepta from '@/popups/services/payments/CMPaymentAxepta.vue'

import BankAccountQRCode from '@/popups/bankAccounts/BankAccountQRCode.vue'

import ChoiceBankAccount from '@/popups/services/payments/ChoiceBankAccount.vue'

import ChoicePaymentCancel from '@/popups/services/payments/ChoicePaymentCancel.vue'

import ChoicePaymentInstalment from '@/popups/services/payments/ChoicePaymentInstalment.vue'

import ChoicePaymentRefuse from '@/popups/services/payments/ChoicePaymentRefuse.vue'

import ChoiceRejectPayment from '@/popups/services/payments/ChoiceRejectPayment.vue'

import DocumentViewer from '@/popups/attachments/DocumentViewer.vue'

import scannerQRCode from '@/popups/services/payments/ScannerQRCode.vue'

import CMChangePasswordPopup from './user/CMChangePasswordPopup.vue'

import CMUserResetPassword from '@/popups/user/CMUserResetPassword.vue'

import importFilePain008 from '@/popups/importFilePain008/importFilePopup.vue'

import xmlDetails from '@/popups/services/payments/CMXmlDetails.vue'

export default {
  name: 'cm-popups',
  components: {
    'choice-bank-account': ChoiceBankAccount,
    'choice-payment-cancel': ChoicePaymentCancel,
    'choice-payment-instalment': ChoicePaymentInstalment,
    'choice-payment-refuse': ChoicePaymentRefuse,
    'choice-reject-payment': ChoiceRejectPayment,
    'cm-attachments-devis-form': CMAttachmentsDevisForm,
    'cm-change-password-popup': CMChangePasswordPopup,
    'cm-contact-add-popup': CMAddContact,
    'cm-contact-group-add-popup': CMAddContactGroup,
    'cm-contact-edit-popup': CMEditContact,
    'cm-payment-axepta': CMPaymentAxepta,
    'cm-user-reset-password': CMUserResetPassword,
    'cm-service-popups': CMServicePopups,
    'cm-service-switcher-popup': ServicesSwitcherPopup,
    'cm-switch-profile': ProfileSwitcherPopup,
    'document-viewer': DocumentViewer,
    'bank-account-qr-code': BankAccountQRCode,
    'scanner-qr-code': scannerQRCode,
    'import-file': importFilePain008,
    'xml-details': xmlDetails
  },
  data () {
    return {
      changePasswordPopup: false,
      changePasswordPopupData: '',
      choiceBankAccount: false,
      choiceBankAccountData: '',
      choicePaymentCancel: false,
      choicePaymentCancelData: '',
      choicePaymentInstalment: false,
      choicePaymentInstalmentData: '',
      choicePaymentRefuse: false,
      choicePaymentRefuseData: '',
      choiceRejectPayment: false,
      choiceRejectPaymentData: '',
      devisForm: false,
      devisFormData: '',
      documentViewer: false,
      documentViewerData: '',
      paymentAxepta: false,
      paymentDetails: '',
      bankAccountQRCode: false,
      accountId: '',
      scannerQRCode: false,
      scannerQRCodeContent: '',
      importFile: false,
      importFileData: '',
      xmlDetails: false,
      xmlDetailsData: ''
    }
  },
  created () {
    this.$bus.$on('close-all-popups', () => {
      this.changePasswordPopup = false
      this.choiceBankAccount = false
      this.choicePaymentCancel = false
      this.choicePaymentInstalment = false
      this.choicePaymentRefuse = false
      this.choiceRejectPayment = false
      this.devisForm = false
      this.documentViewer = false
      this.paymentAxepta = false
      this.bankAccountQRCode = false
      this.scannerQRCode = false
      this.importFile = false
      this.xmlDetails = false
    })
    this.$bus.$on('popup-change-password-data', e => {
      this.changePasswordPopupData = e
      this.changePasswordPopup = true
    })
    this.$bus.$on('popup-choice-bank-account', e => {
      this.choiceBankAccountData = e
      this.choiceBankAccount = true
    })
    this.$bus.$on('popup-choice-payment-cancel', e => {
      this.choicePaymentCancelData = e
      this.choicePaymentCancel = true
    })
    this.$bus.$on('popup-choice-payment-instalment', e => {
      this.choicePaymentInstalmentData = e
      this.choicePaymentInstalment = true
    })
    this.$bus.$on('popup-choice-payment-refuse', e => {
      this.choicePaymentRefuseData = e
      this.choicePaymentRefuse = true
    })
    this.$bus.$on('popup-choice-reject-payment', e => {
      this.choiceRejectPaymentData = e
      this.choiceRejectPayment = true
    })
    this.$bus.$on('popup-devis-form', e => {
      this.devisFormData = e
      this.devisForm = true
    })
    this.$bus.$on('popup-document-viewer', e => {
      this.documentViewerData = e
      this.documentViewer = true
    })
    this.$bus.$on('popup-payment-axepta', e => {
      this.paymentDetails = e
      this.paymentAxepta = true
    })
    this.$bus.$on('popup-bank-account-qr-code', e => {
      this.accountId = e
      this.bankAccountQRCode = true
    })
    this.$bus.$on('popup-scanner-qr-code', e => {
      this.scannerQRCodeContent = e
      console.log('On ', this.scannerQRCodeContent)
      this.scannerQRCode = true
    })
    this.$bus.$on('popup-import-file', e => {
      this.importFileData = e
      this.importFile = true
    })
    this.$bus.$on('popup-xml-details', e => {
      this.xmlDetailsData = e
      this.xmlDetails = true
    })
  }
}
</script>
